<template>
    <div class='t_content_view'>
        <el-page-header @back="goBack" content="新建群发" />
        <div  class="t_sxtips">
            <WarningFilled style="color: #4F46E5;width: 14px;margin-right: 5px;" />
            每位客户每天可接收1条群发消息，可以是企业统一创建发送的，也可以是成员自己创建发送的；超过接收上限的客户将无法再收到群发消息。
          
        </div>
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>群发基础信息</div>
        </div>
        <div class="t_con_box_f" style="align-items:center">
            <div class="t_con_title_f">* 群发标题：</div>
            <div>
                <el-input v-model="sendtitle" maxlength="20" style="width: 600px;"  placeholder="请输入群发标题，最多20个字"  clearable />
            </div>
        </div>
        <div class="t_con_box_f" >
            <div class="t_con_title_f">* 选择客户：</div>
            <div>
                <el-checkbox @change="checked=>choosetype(checked,1)" v-model="text_type1" label="全部客户" size="large" />
                <el-checkbox @change="checked=>choosetype(checked,2)" v-model="text_type2" label="按条件筛选" size="large" />
                <el-checkbox @change="checked=>choosetype(checked,3)" v-model="text_type3" label="导入人群包" size="large" />
                <!-- <el-checkbox @change="checked=>choosetype(checked,3)" v-model="text_type3" label="选择敢探号人群" size="large" /> -->
                <div v-if="text_type2" class="t_tiaojian_box">
                    <div class="t_tiaojian_item">
                        <div>添加渠道：</div>
                        <el-select v-model="quDaoIds.data" 
                        placeholder="请选择渠道"
                        multiple
                        style="width: 370px;"
                        value-key="id" >
                            <el-option v-for="(item,index) in allqdlist.data" 
                            :key="index"
                            :label="item.title" 
                            :value="item.id" />
                        </el-select>
                    </div>
                    <div class="t_tiaojian_item">
                        <div>企业主体：</div>
                        <el-select style="width: 370px;" v-model="corp_id" placeholder="请选择企业主体" >
                            <el-option
                            v-for="(item,index) in allcomp.data"
                            :key="index"
                            :label="item.corp_name"
                            :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div class="t_tiaojian_item">
                        <div>添加日期：</div>
                        <el-date-picker
                            v-model="adddate.data"
                            @change="changeTime"
                            style="width: 370px;"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                        />
                    </div>
                    <div class="t_tiaojian_item" style="align-items:flex-start">
                        <div style="flex-shrink:0 ">客户标签：</div>
                        <chooseTag  :choosedtag="choosedtag" :bqData="bqData" @changechoosedtag="changechoosedtag"
                        @changebqData = 'changebqData' />
                    </div>
                    <div class="t_line_gray_dash"></div>
                    <div class="t_tiaojian_item" >
                        <div>排除制定条件的客户</div>
                        <el-switch
                            v-model="isExit"
                            style="--el-switch-on-color: #4F46E5;margin-left: 10px; "
                        />
                    </div>
                    <div style="font-size: 13px;color: #777777;">在上方选中的客户里，满足排除条件的客户将被过滤</div>
                </div>
                <div v-if="text_type3" class="t_tiaojian_box" >
                    <div class="t_tiaojian_item">
                        <div>导入类型：</div>
                        <el-radio-group v-model="importType">
                            <el-radio value="phone">手机号</el-radio>
                            <el-radio value="contactid">客户ID</el-radio>
                        </el-radio-group>
                    </div>
                    <div style="display:flex;align-items:center;">
                        <el-button :disabled="route.query.type=='bj'" @click="downloadExcel" :icon="Download" type="primary">下载模板</el-button>
                        <el-button @click="getxslx" type="primary">导入模板</el-button>
                        <div style="font-size: 15px; margin-left: 10px;color:#67C23A" v-if="excelfile.length>0 || contactidsfile.length>0">已上传</div>
                    </div>
                    
                    <!-- <div class="t_tiaojian_item" style="align-items: start;">
                        <div style="width: 100px;">输入号码：</div>
                        <el-input
                        type="textarea"
                        placeholder="请粘贴号码，一行一个"
                        v-model="copynum"
                        :rows="10"
                         clearable></el-input>
                    </div>
                    <el-button @click="jskhcount" color="#4F46E5" style="margin-left: 85px;" plain>匹配计算</el-button>
                    <div v-if="numclick" style="margin-left: 85px;margin-top: 15px;">
                        共计<span>{{ copynumnum }}</span>个，匹配成功:<span style="color:green;margin-right: 15px;">{{ copyres.data.count }}</span>匹配失败:<span style="color:red;margin-right: 15px;">{{ copyres.data.failed_count }}</span>
                        <span v-if="copyres.data.failed_url" @click="xaizai(copyres.data.failed_url)" style="color:#4F46E5;cursor: pointer;">下载失败数据</span>
                    </div> -->
                    <!-- <div style="display:flex;" >
                        <el-input size="small" v-model="gthinput" placeholder="请输入搜索内容" style="margin-right: 10px;width: 230px;"  clearable />
                        <el-button @click="searchgth" size="small" >检索</el-button>
                    </div>
                    <div class="t_gth_list" v-for="(item,index) in gthfriend.data" :key="index">
                        <div >
                            <div style="display: flex;justify-content: space-between;align-items: center;width: 500px;">
                                <div>
                                    <el-tag
                                    size="small"    
                                    effect="dark">{{ item.type }}</el-tag>
                                    <span style="font-size: 15px;margin-left: 10px;">{{ item.title }}</span>
                                </div>
                                <div style="font-size: 15px;">数量：{{ item.user_amount }}</div>
                            </div>
                            <div style="font-size: 15px;color: #B0B0B0;margin-top: 5px;">{{ item.remark }}</div>
                        </div>
                        <div>
                            <div v-if="item.ischoose" >已选择</div>
                            <el-button v-if="!item.ischoose" @click="choosegthbtn(item)" size="small" type="primary" plain>选择</el-button>
                        </div>
                    </div> -->
                </div>
                <div v-if="!text_type3" class="t_js_box">
                    <img src="../assets/img/js.png" style="width: 10px;" alt="">
                    点击<span @click="jskhcount">计算</span>满足条件的客户数量
                    <div style="color: #4F46E5;margin-left: 10px;" v-if="showkhcount !== ''">当前数量{{ showkhcount }}</div>
                </div>
            </div>
        </div>
        <!-- line -->
        <div class="t_line"></div>
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>群发内容</div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f">发送文案：</div>
            <div style="position:relative" >
                <!-- 要提交的文案 -->
                <div >
                    <draggable
                    
                    v-model="ready_list.data"
                    @start="drag = true"
                    @end="drag = false"
                    item-key="index"
                    >
                    <template #item="{ element, index }">
                        <div class="t_ready_msg" >
                            <div style="display:flex;align-items: center;">
                                <img style="width: 7px;height:16px;margin-right: 15px;" src="../assets/img/move.png">
                                <!-- 文字 -->
                                <div :style="{display:(element.msg_type=='Text'?'block':'none')}" style="width: 530px;">{{ element.content }}</div>
                                <!-- 网页 -->
                                <div :style="{display:(element.msg_type=='Link'?'block':'none')}" style="width: 530px;">{{ element.jcontent.title }}</div>
                                <!-- 视频 -->
                                <div :style="{display:(element.msg_type=='Video'?'block':'none')}">{{ element.desc }}</div>
                                <!-- 图片 -->
                                <img :style="{display:(element.msg_type=='Picture'?'block':'none')}" :src="element.thumbUrl" style="width: 64px;" alt="">
                            </div>
                            <div>
                                <EditPen @click="edit_ready(index)" style="width: 20px;color: #8F8F8F;" />
                                <Delete @click="del_ready(index)" style="width: 20px;color: #8F8F8F;margin-left: 15px;" />
                            </div>
                        </div>
                    </template>
                    </draggable>
                    
                </div>
                <!-- 添加、编辑 -->
                <div class="t_speak_box">
                    <!-- 群发种类 -->
                    <div class="t_sendytpe_box">
                        <div :class="{ 't_sendytpe_lei': sendtype=='Text' }" @click="changesendtype('Text')">文本</div>
                        <div :class="{ 't_sendytpe_lei': sendtype=='Link' }" style="margin-left: 30px;margin-right: 30px;" @click="changesendtype('Link')">网页</div>
                        <div style="margin-right: 30px;"  :class="{ 't_sendytpe_lei': sendtype=='Picture' }" @click="changesendtype('Picture')">图片</div>
                        <div :class="{ 't_sendytpe_lei': sendtype=='Video' }" @click="changesendtype('Video')">视频</div>
                    </div>
                    <!-- 文本 -->
                    <div v-if="sendtype=='Text'">
                        <el-input 
                        @focus="focusinput(1)" 
                        @input="textchange" 
                        @blur="testBlur"
                        v-model="emojisOutput" class="t_speak_input" style="border-bottom:1px solid #c2c2c2" placeholder="请输入群发内容，限1000个字" maxlength="1000" rows="10" type="textarea"  clearable />
                        <div style="display: flex;align-items: center;justify-content: space-between;padding: 10px;">
                            <img src="../assets/img/emoji.png" class="t_emoji_img" @click="showemoji" alt="">
                            <div>
                                <el-button  
                                @click="rest_ready"
                                class="t_add_people"   >取消</el-button>
                                <el-button @click="add_ready" color="#4F46E5" class="t_add_people" type="primary"  >添加</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- 网页 -->
                    <div v-if="sendtype=='Link'">
                        <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                            <div class="t_con_title_f" style="width: 120px;">* 链接：</div>
                            <div>
                                <el-input
                                 v-model="weblink" 
                                 @input="weblinkchange" 
                                 style="width: 400px;"  placeholder="请输入链接"  clearable />
                            </div>
                        </div>
                        <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                            <div class="t_con_title_f" style="width: 120px;">* 网页标题：</div>
                            <div class="t_web_con">
                                <el-input 
                                @input="webconchange"
                                @focus="focusinput(2)"
                                @blur="testBlur"
                                v-model="webcon_emojisOutput" class="t_speak_input"  placeholder=""  rows="5" type="textarea"  clearable />
                                <img src="../assets/img/emoji.png" class="t_emoji_img" @click="showemoji" alt="">
                            </div>
                        </div>
                        <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                            <div class="t_con_title_f" style="width: 120px;">* 网页描述：</div>
                            <div class="t_web_con">
                                <el-input 
                                @focus="focusinput(3)"
                                @blur="testBlur"
                                @input="webdeschange"
                                v-model="webdes_emojisOutput" class="t_speak_input"  placeholder=""  rows="5" type="textarea"  clearable />
                                <img src="../assets/img/emoji.png" class="t_emoji_img" @click="showemoji" alt="">
                            </div>
                        </div>
                        <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                            <div class="t_con_title_f" style="width: 120px;">* 网页图标：</div>
                            <div>   
                                <el-upload
                                :headers="headers"
                                class="avatar-uploader"
                                :action="upload_img"
                                :data="upData"
                                accept="image/jpg,image/jpeg,image/png"
                                :show-file-list="false"
                                :on-success="web_handleAvatarSuccess"
                                :before-upload="web_beforeAvatarUpload">
                                <img v-if="web_imgurl" :src="web_imgurl" class="avatar" />
                                    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                                </el-upload>
                                <div style="width: 400px;font-size: 13px;color: #777777;margin-top: 10px;">
                                    建议图片比例1:1，图片大小不能超过2MB，分辨率不能超过1080*1080，支持jpg、jpeg、png格式
                                </div>
                                <div style="margin-top:20px;padding-bottom:50px;display:flex;justify-content:end">
                                    <el-button @click="rest_ready" class="t_add_people"   >取消</el-button>
                                    <el-button 
                                    @click="add_ready" color="#4F46E5" class="t_add_people" type="primary"  >添加</el-button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <!-- 图片 -->
                    <div v-if="sendtype=='Picture'">
                        <div style="width: 560px;margin-left: auto;margin-right: auto;">
                            <el-form @paste.native="handlePaste">
                                <el-input v-model="niantie" style="width: 100%;margin-top:15px"  placeholder="复制粘贴上传图片"  clearable />
                            </el-form>
                            
                            <el-upload
                                drag
                                ref="upload"
                                :headers="headers"
                                :action="upload_img"
                                :data="upData"
                                accept="image/jpg,image/jpeg,image/png"
                                :on-success="img_handleAvatarSuccess"
                                :before-upload="img_beforeAvatarUpload"
                                :show-file-list="false"
                                style="margin-top:15px;margin-bottom:15px"
                                multiple>
                                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                                <div class="el-upload__text">
                                    拖拽或点击上传图片
                                </div>
                            </el-upload>
                            <img v-if="img_imgurl" :src="img_imgurl" class="avatar2" />
                            <div style="margin-top:20px;padding-bottom:50px;display:flex;justify-content:end">
                                <el-button  class="t_add_people" @click="rest_ready"  >取消</el-button>
                                <el-button @click="add_ready"  color="#4F46E5" class="t_add_people" type="primary"  >添加</el-button>
                            </div>
                        </div>
                        
                    </div>
                    <!-- 视频 -->
                    <div v-if="sendtype=='Video'">
                        <div style="width: 560px;margin-left: auto;margin-right: auto;">
                            <el-upload
                                style="margin-top:20px"
                                :data="upData"
                                v-model:file-list="fileList_video.data"
                                :action=upload_img
                                accept="video/mp4" 
                                :on-success="successvideo"
                                :before-upload="video_beforeAvatarUpload"
                                :headers="headers"
                            >
                                <el-button >选择视频</el-button>
                            </el-upload>
                            <div style="margin-top:20px;padding-bottom:50px;display:flex;justify-content:end">
                                <el-button @click="rest_ready" class="t_add_people"   >取消</el-button>
                                <el-button 
                                @click="add_ready" color="#4F46E5" class="t_add_people" type="primary"  >添加</el-button>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <Picker style="position: absolute;top: 0;left: 620px;" v-if='isshowemoji' :data="emojiIndex" set="twitter" @select="selectEmoji" />
            </div>
        </div>
        <div class="t_con_box_f">
        <div class="t_con_title_f">发送时间：</div>
        <div>
            <div>
            <el-checkbox @change="nowsendchange" v-model="nowsend" label="立即发送" size="large" />
            </div>
            <div>
            <el-checkbox @change="timesendchange" 
            style="margin-right: 20px;" v-model="timesend" label="定时发送" size="large" />
            <el-date-picker
                class="t_choosetime"
                v-model="sendtime"
                value-format="YYYY-MM-DD HH:mm:ss"
                type="datetime"
                placeholder="请选择时间"
            />
            </div>
        </div>
        </div>
        <div class="t_con_box_f">
        <el-button  color="#4F46E5" @click="sendfriend" style="margin-left:150px" type="primary">发送</el-button>
        </div>
    </div>
</template>

<script setup>
import data from "emoji-mart-vue-fast/data/all.json";
// Import default CSS
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";


import { ref, reactive, provide, onBeforeMount, onMounted, watch, inject,getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox,UploadProps, UploadUserFile } from 'element-plus'
import { Download,Upload } from '@element-plus/icons-vue'
import { bqlist ,qdmlist,sendall,checknum,getgthlist,newgethmqdlist,newgettaglist,newgetnums,newcreateall,newgetcomp2} from '@/assets/js/common.js'
import chooseTag from '../components/chooseTag.vue';
import draggable from 'vuedraggable'
import * as XLSX from 'xlsx';//vue3 引入写法
import { decode,encode} from '@/assets/js/base64.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()

//动态获取接口地址
const _url2 = inject('_url2')
const _urlfile = '/api/upload/file'
const headers = {
  'Authorization': 'Bearer ' + $cookies.get("fanstoken")
}

onMounted(() => {
    //获取标签列表
    getbqlist()
    //获取所有渠道下拉
    getallqdlist()
    //获取主体
    getcomplist()
    //剪切板上传图片
    var currentInstance = getCurrentInstance()
    document.body.onpaste = function (event) {
        let data = event.clipboardData || window.clipboardData
        let items = data.items
        if (items && items.length) {
            // 检索剪切板items
           // 限制上传文件类型
            if (items[0].type.indexOf('image') !== -1) {
                let file = items[0].getAsFile();
                // 生成预览图
                currentInstance.proxy.$refs.upload.handleStart(file);
                currentInstance.proxy.$refs.upload.submit();
            }
        }
    }
})
//返回
const goBack = () => {
    router.push({ path: '/navxxcd/allsendmsg' })
}
//群发标题
const sendtitle = ref('')
//企业主体
const corp_id = ref('')

//选择客户
const text_type1 = ref(true)
const text_type2 = ref(false)
const text_type3 = ref(false)
//选择客户条件
const choosetype = (value,type)=>{
    console.log(value,type)
    showkhcount.value=''
    if(type==1){
        //全部
        text_type1.value = true
        text_type2.value = false
        text_type3.value = false

        //清空筛选选项
        quDaoIds.data = []
        adddate.data = []
        isExit.value = false
        choosedtag.data = []
        corp_id.value = ''
        excelfile.value = []
        contactidsfile.value = []
        //添加是否选中状态
        for(var i=0;i<bqData.data.length;i++){
            for(var x=0;x<bqData.data[i].tags.length;x++){
                bqData.data[i].tags[x].checked=false
            }
        }
    }else if(type==2){
        //筛选
        text_type1.value = false
        text_type2.value = true
        text_type3.value = false
        excelfile.value = []
        contactidsfile.value = []

    }else if(type==3){
        //感叹号
        text_type1.value = false
        text_type2.value = false
        text_type3.value = true

        //清空筛选选项
        quDaoIds.data = []
        adddate.data = []
        isExit.value = false
        choosedtag.data = []
        corp_id.value = ''
        //添加是否选中状态
        for(var i=0;i<bqData.data.length;i++){
            for(var x=0;x<bqData.data[i].tags.length;x++){
                bqData.data[i].tags[x].checked=false
            }
        }
    }
}
//所有渠道下拉
const allqdlist = reactive({
    data:[]
})
//获取所有渠道下拉
const getallqdlist = ()=>{
    newgethmqdlist({ pageNo:1,
    pageSize:200000,
    channel_title:'',
    channel_type_id:''}).then((response)=>{
        if (response.data.msg.code == 0) {
            
            allqdlist.data =  response.data.data.data
        }
    })
}
//选择的渠道
const quDaoIds = reactive({
    data:[]
})

//添加日期
const adddate = reactive({
    data:[]
})
//时间条件
const changeTime = (e)=>{
    console.log(e)
    if(e==null){
        adddate.data = []
    }
}
//是否排除
const isExit = ref(false)
//搜索敢探号
const gthinput = ref('')
const searchgth = ()=>{
    if(gthinput.value!=''){
        choosegth.data = {}
        getgthlist(_url2,{title:gthinput.value,type:0}).then((response)=>{
            console.log('搜索敢探号')
            console.log(response.data.result)
            gthfriend.data = response.data.result
        })
    }else{
        ElMessage.error('请输入搜索内容')
    }
}
//感叹号好友列表
const gthfriend = reactive({
    data:[]
})
//选择的感叹号列表
const choosegth = reactive({
    data:{}
})
//点击选择敢探号
const choosegthbtn = (item)=>{
    choosegth.data = item
    for(var x = 0;x<gthfriend.data.length;x++){
        if(gthfriend.data[x].id==item.id){
            gthfriend.data[x].ischoose=true
        }else{
            gthfriend.data[x].ischoose=false
        }
    }
}
//粘贴号码
const copynum = ref('')
//粘贴号码数量
const copynumnum = ref('0')
//粘贴号码结果
const copyres = reactive({
    data:{}
})
//json导出表格
const exportxslx = ()=>{
        
        let tableData = [["手机号"]];
        copyres.data.falid_arr.forEach ((item,index)=> {
            let rowData = []
            //导出内容的字段
            rowData = [
                item
            ]
            tableData.push(rowData)
        })
        let ws = XLSX.utils.aoa_to_sheet(tableData)
        let wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '失败数据') // 工作簿名称
        XLSX.writeFile(wb, '失败数据.xlsx') // 保存的文件名
            
}
//展示结果
const numclick = ref(false)
//计算数量
const showkhcount = ref('')




const jskhcount = ()=>{
    //判断是所有人还是筛选
    if(text_type1.value){
        var type = 1 
    }else if(text_type2.value){
        var type = 2
    }else if(text_type3.value){
        var type = 3
    }

    var obj = {
        "condition":{
            mobiles:[],
            tag_ids:[],
            channel_ids:[],
            equal:1,
            start_time:'',
            end_time:'',
        }
    }

    if(type==1){
        //全部
        
        newgetnums(obj).then((response)=>{
            console.log(response.data)
            // if(response.data.result==null){
            //     ElMessage({
            //         showClose: true,
            //         message: response.data.message,
            //         type: 'error',
            //     })
            //     return
            // }
            showkhcount.value = response.data.data.count
        })
    }else if(type==2){
        //筛选
        if(quDaoIds.data.length==0&&adddate.data.length==0&&choosedtag.data.length==0&&corp_id.value==''){
            ElMessage({
                showClose: true,
                message: '请选择筛选内容',
                type: 'error',
            })
            return
        }
        // var condition={
        //     type:type,
        //     quDaoIds:shaixuan().quDaoIdsstr.join(","),//选择渠道
        //     startTime:shaixuan().startTime,//开始时间
        //     endTime:shaixuan().endTime,//结束时间
        //     tagIds:shaixuan().tag_list.join(","),//标签
        //     isExit:shaixuan().isExitstr,//是否排除
        // }
        // console.log(condition)
        // return
        obj.condition.tag_ids = shaixuan().tag_list,//标签
        obj.condition.channel_ids = shaixuan().quDaoIdsstr,//选择渠道
        obj.condition.start_time  = shaixuan().startTime,//开始时间
        obj.condition.end_time = shaixuan().endTime,//结束时间
        obj.condition.equal  = shaixuan().isExitstr,//是否排除
        obj.condition.corp_id = corp_id.value,//企业主体

        // shaixuanobj.data = obj
        newgetnums(obj).then((response)=>{
            // console.log(response.data.result)
            // if(response.data.result==null){
            //     ElMessage({
            //         showClose: true,
            //         message: response.data.message,
            //         type: 'error',
            //     })
            //     return
            // }
            showkhcount.value = response.data.data.count
        })
    }else if(type==3){
        if(importType.value=='phone'){
            obj.condition.mobiles = excelfile.value
            copynumnum.value = excelfile.value.length
        }else{
            obj.condition.contact_ids = contactidsfile.value
            copynumnum.value = contactidsfile.value.length
        }

        // shaixuanobj.data = obj
        newgetnums(obj).then((response)=>{
            console.log(response.data)
            // return
            // if(response.data.result==null){
            //     ElMessage({
            //         showClose: true,
            //         message: response.data.message,
            //         type: 'error',
            //     })
            //     return
            // }
            copyres.data = response.data.data
            numclick.value = true
        })
    }
    
}

//下载
const xaizai = (url)=>{
    window.open(window.location.origin+url,'_blank')
}



// =================内容模块==================
//选择群发种类
const sendtype = ref('Text')
const changesendtype = (type)=>{
    sendtype.value = type
    temporary.data.msg_type = type
    whichinput.value =0
}



//文字===
//表情数据
const emojiIndex = new EmojiIndex(data)
//是否显示emoji选择框
const isshowemoji = ref(false)
//打开emoji选择框
const showemoji = ()=>{
  isshowemoji.value=!isshowemoji.value
}


//输入框内容
const emojisOutput = ref('')

//监听输入框变化
const textchange = (e)=>{
    //内容添加到临时编辑内容中
    temporary.data.content = emojisOutput.value
}

//设置文本类型或网页类型，三个输入框到底选中了哪个输入框
const whichinput = ref(0)
//获得焦点，选中输入框
const focusinput = (i)=>{
    whichinput.value = i
}
// 储存焦点位置
const Blurindex = ref(null)
//获取焦点位置
const testBlur = (e)=>{
    console.log('获取焦点')
    console.log(e.srcElement.selectionStart)
    Blurindex.value = e.srcElement.selectionStart
}
//监听选表情
const selectEmoji = (emoji)=> {
    //根据焦点确认往那个输入框中输入表情
    if(whichinput.value==1){
        //文本类型的输入框
        var yuantest = emojisOutput.value
        emojisOutput.value = yuantest.slice(0,Blurindex.value)+emoji.native+yuantest.slice(Blurindex.value)
        // emojisOutput.value = emojisOutput.value + emoji.native;
        //内容添加到临时编辑内容中
        temporary.data.content = emojisOutput.value
    }else if(whichinput.value==2){
        //网页标题
        var yuantest = webcon_emojisOutput.value
        webcon_emojisOutput.value = yuantest.slice(0,Blurindex.value)+emoji.native+yuantest.slice(Blurindex.value)

        // webcon_emojisOutput.value = webcon_emojisOutput.value + emoji.native;
        //内容添加到临时编辑内容中
        temporary.data.jcontent.title = webcon_emojisOutput.value
    }else if(whichinput.value==3){
        //网页描述
        var yuantest = webdes_emojisOutput.value
        webdes_emojisOutput.value = yuantest.slice(0,Blurindex.value)+emoji.native+yuantest.slice(Blurindex.value)

        // webdes_emojisOutput.value = webdes_emojisOutput.value + emoji.native;
        //内容添加到临时编辑内容中
        temporary.data.desc = webdes_emojisOutput.value
        temporary.data.jcontent.desc = webdes_emojisOutput.value
    }
  
} 


const upData=reactive(
  { file: '', file_type: '' }
)  // 上传文件data
//网页===

//网页链接
const weblink = ref('')
const weblinkchange = ()=>{
    //内容添加到临时编辑内容中
    temporary.data.jcontent.url = weblink.value
}

//网页标题
const webcon_emojisOutput = ref('')
const webconchange = ()=>{
    //内容添加到临时编辑内容中
    temporary.data.jcontent.title = webcon_emojisOutput.value
}

//网页描述
const webdes_emojisOutput = ref('')
const webdeschange = ()=>{
    //内容添加到临时编辑内容中
    temporary.data.desc = webdes_emojisOutput.value
    temporary.data.jcontent.desc = webdes_emojisOutput.value
}


//上传图片地址
const upload_img = _urlfile
// const headers = reactive({
//   'token': $cookies.get("fanstoken")
// })
//网页缩略图
//回显地址
const web_imgurl = ref('')
//上传返回参数
// const web_imgurl_result = ref('')

//上传成功
const web_handleAvatarSuccess = (response,uploadFile)=>{
    
   
    web_imgurl.value = response.data.url
    // web_imgurl_result.value = response.result
    //存入临时储存待发送内容
    temporary.data.thumbUrl = web_imgurl.value 
    temporary.data.jcontent.thumbUrl = web_imgurl.value 
    console.log('上传成功')
    console.log(response)
    console.log(web_imgurl.value)
}
//上传前检测
const web_beforeAvatarUpload = (rawFile)=>{
    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
    upData.file = rawFile
    upData.file_type = 'image'
    return true
}

//图片===
//回显地址
const img_imgurl = ref('')
//上传返回参数
// const img_imgurl_result = ref('')

//复制黏贴输入框
const niantie = ref('')
const img_beforeAvatarUpload = (rawFile)=>{
    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
    upData.file = rawFile
    upData.file_type = 'image'
    return true
}
//拖拽点击上传成功
const img_handleAvatarSuccess = (response,uploadFile)=>{
    
   
    img_imgurl.value = response.data.url
    // img_imgurl_result.value = response.result

    //存入临时储存待发送内容
    temporary.data.thumbUrl = img_imgurl.value 
    temporary.data.content = img_imgurl.value 
    console.log('上传成功')
    console.log(response)
    console.log(response.data.url)
}

//视频===

//上传文件列表
const fileList_video = reactive({
  data:[]
})
const video_beforeAvatarUpload = (rawFile)=>{

    upData.file = rawFile
    upData.file_type = 'video'
    return true
}
//上传视频成功
const successvideo = (val)=>{
  
  //上传失败
  if(val.code==500){
    ElMessage.error('上传失败')
    fileList_video.data.pop()
  }else if(fileList_video.data.length>1){
    fileList_video.data.shift()
  }
  //存入临时储存待发送内容
//   temporary.data.thumbUrl = val.result.url
//   temporary.data.desc = fileList_video.data[0].name
//   temporary.data.content = fileList_video.data[0]

  temporary.data.content = val.data.url
  temporary.data.desc = fileList_video.data[0].name
  temporary.data.thumbUrl = fileList_video.data[0]
  console.log(val)
  console.log(fileList_video.data)
}

//编辑好的待发送列表
const ready_list = reactive({
    data:[]
})
//编辑待发送列表
const edit_ready = (index)=>{
    //先走一遍取消，不然连续点几两个编辑，数据会丢失
    rest_ready()
    //修改类型
    sendtype.value = ready_list.data[index].msg_type
    temporary.data.msg_type = ready_list.data[index].msg_type
    whichinput.value =0
    //根据类型编辑数据
    if(sendtype.value=='Text'){
        emojisOutput.value = ready_list.data[index].content
    }
    if(sendtype.value=='Picture'){
        img_imgurl.value = ready_list.data[index].thumbUrl
    }
    if(sendtype.value=='Link'){
        weblink.value = ready_list.data[index].jcontent.url
        web_imgurl.value = ready_list.data[index].thumbUrl
        webcon_emojisOutput.value = ready_list.data[index].jcontent.title
        webdes_emojisOutput.value = ready_list.data[index].desc
    }
    if(sendtype.value=='Video'){
        fileList_video.data.push(ready_list.data[index].thumbUrl)
    }
    //将该项存入编辑修改数组中
    edit_temporary.data =  JSON.parse(JSON.stringify(ready_list.data[index]))
    //将该项存入待发送数组中
    temporary.data =  JSON.parse(JSON.stringify(ready_list.data[index]))
    //从待发送列表中删除该项
    del_ready(index)
}
//删除待发送列表
const del_ready = (index)=>{
    console.log(index)
    ready_list.data.splice(index,1)
}
//编辑修改待发送内容
const edit_temporary = reactive({
    data:{
        msg_type:'',//种类
        content:'',//内容
        desc:'',//描述
        thumbUrl:'',//图片地址或网站地址
        jcontent:{
            desc:'',
            thumbUrl:'',
            title:'',
            url:'',
        },//网页内容

    }
})
//临时储存待发送内容
const temporary = reactive({
    data:{
        msg_type:'Text',//种类
        content:'',//内容
        desc:'',//描述
        thumbUrl:'',//图片地址或网站地址
        jcontent:{
            desc:'',
            thumbUrl:'',
            title:'',
            url:'',
        },//网页内容

    }
})
//临时添加到待发送
const add_ready = ()=>{
    //判断当前种类
    if(sendtype.value == 'Text'){
        if(emojisOutput.value == ''){
            ElMessage({
                showClose: true,
                message: '请确认发送内容',
                type: 'error',
            })
            return
        }
    }else if(sendtype.value == 'Picture'){
        if(img_imgurl.value == ''){
            ElMessage({
                showClose: true,
                message: '请确认发送内容',
                type: 'error',
            })
            return
        }
    }else if(sendtype.value == 'Link'){
        if(weblink.value==''||webcon_emojisOutput.value==''||webdes_emojisOutput.value==''||web_imgurl.value==''){
            ElMessage({
                showClose: true,
                message: '请确认发送内容',
                type: 'error',
            })
            return
        }
    }else if(sendtype.value == 'Video'){
        if(fileList_video.data.length==0){
            ElMessage({
                showClose: true,
                message: '请确认发送内容',
                type: 'error',
            })
            return
        }
    }
    console.log(temporary.data)
    ready_list.data.push(JSON.parse(JSON.stringify(temporary.data)))
    rest_ready(1)
    
    
}
//取消编辑
const rest_ready = (num)=>{
    //判断修改编辑中是否有数据，有数据将修改数据重新放入待发送列表中
    //如果有参，说明是走了添加，则不将编辑修改内容重新放入待发送列表
    if((edit_temporary.data.content!=''||edit_temporary.data.thumbUrl!='')&&num!=1){
        ready_list.data.push(JSON.parse(JSON.stringify(edit_temporary.data)))
    }
    //清除临时储存待发送内容
    temporary.data.content = ''
    temporary.data.desc = ''
    temporary.data.thumbUrl = ''
    temporary.data.jcontent = {
            desc:'',
            thumbUrl:'',
            title:'',
            url:'',
        },//网页内容
    //清除编辑修改待发送内容
    edit_temporary.data.content = ''
    edit_temporary.data.desc = ''
    edit_temporary.data.thumbUrl = ''
    edit_temporary.data.jcontent = {
            desc:'',
            thumbUrl:'',
            title:'',
            url:'',
        },//网页内容
    //清除文本类型输入框
    emojisOutput.value = ''
    //清除图片类型内容
    img_imgurl.value = ''
    // img_imgurl_result.value = ''
    //清除网页内容
    weblink.value = ''
    web_imgurl.value = ''
    webcon_emojisOutput.value = ''
    webdes_emojisOutput.value = ''
    //清除视频内容
    fileList_video.data = []

}

//发送时间
//立即发送
const nowsend = ref(true)
//立即发送状态改变
const nowsendchange = (val)=>{
  if(val){
    timesend.value = false
    sendtime.value = ''
  }else{
    nowsend.value = true
  }
}
//定时发送
const timesend = ref(false)
//定时发送状态改变
const timesendchange = (val)=>{
  if(val){
    nowsend.value = false
  }else{
    timesend.value = true
  }
}

//定时发送时间
const sendtime = ref('')

//获取当前时间年月日时分秒
const getNowDate = ()=>{
    var date = new Date();
    var sign2 = ":";
    var year = date.getFullYear() // 年
    var month = date.getMonth() + 1; // 月
    var day = date.getDate(); // 日
    var hour = date.getHours(); // 时
    var minutes = date.getMinutes(); // 分
    var seconds = date.getSeconds() //秒
    var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
    var week = weekArr[date.getDay()];
    // 给一位数的数据前面加 "0"
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (day >= 0 && day <= 9) {
        day = "0" + day;
    }
    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    console.log(year + "-" + month + "-" + day + " " + hour + sign2 + minutes )
    //返回格式2022-11-25 10:25:39
    
    return year + "-" + month + "-" + day + " " + hour + sign2 + minutes + sign2 + seconds;
}

//筛选数据整理
const shaixuan = ()=>{
    //选择渠道整理数据
    var quDaoIdsstr = []
    quDaoIdsstr = quDaoIds.data
    // console.log('quDaoIds.data')
    // console.log(quDaoIds.data)
    // for(var x = 0;x<quDaoIds.data.length;x++){
    //     quDaoIdsstr.push(quDaoIds.data[x].id)
    // }

    //开始时间结束时间
    var startTime = ''
    var endTime = ''
    if(adddate.data.length!=0){
         startTime = adddate.data[0]
         endTime = adddate.data[1]
    }

    //选择标签整理
    var tag_list = []
    for(var x=0;x<choosedtag.data.length;x++){
      tag_list.push(choosedtag.data[x].id)
    }

    //是否是排除筛选
    var isExitstr = ''
    if(isExit.value){
        isExitstr = -1
    }else{
        isExitstr = 1
    }

    return {
        quDaoIdsstr:quDaoIdsstr,
        startTime:startTime,
        endTime:endTime,
        tag_list:tag_list,
        isExitstr:isExitstr,
    }
}

//发送
const sendfriend = ()=>{
    //敢探号id
    var gthId = ''
    var sucessPhoneArr = []

    if(sendtitle.value==''){
        ElMessage({
            showClose: true,
            message: '请输入发送标题',
            type: 'error',
        })
        return
    }
    
    
    if(text_type2.value){
        if(quDaoIds.data.length==0&&adddate.data.length==0&&choosedtag.data.length==0){
            ElMessage({
                showClose: true,
                message: '请选择筛选内容',
                type: 'error',
            })
            return
        }
        if(corp_id.value==''){
            ElMessage({
                showClose: true,
                message: '请选择企业主体',
                type: 'error',
            })
            return
        }
    }

    if(text_type3.value){
        // console.log(choosegth.data)
        // if(Object.keys(choosegth.data).length == 0){
        //     ElMessage.error('请选择敢探号人群')
        //     return
        // }else{
        //     gthId = choosegth.data.id
        // }

        if(importType.value=='phone'){
            if(excelfile.value.length==0){
                ElMessage.error('请上传手机号文件')
                return
            }
        }else{
            if(contactidsfile.value.length==0){
                ElMessage.error('请上传客户ID文件')
                return
            }
        }


        // if(!numclick.value){
        //     ElMessage.error('请先匹配计算成功数据')
        //     return
        // }
        // if(copyres.data.count.length==0){
        //     ElMessage.error('暂无匹配计算成功数据')
        //     return
        // }else{
        //     sucessPhoneArr = copyres.data.sucess_arr
        // }
    }

    if(ready_list.data.length==0){
        ElMessage({
            showClose: true,
            message: '请确认发送内容',
            type: 'error',
        })
        return
    }
    
    //发送内容
    //判断是立即发送还是定时发送
    if(nowsend.value){
        // 立即发送不传浏览器时间，由后端按任务创建时间落库，避免浏览器时钟偏差或创建耗时导致执行时间早于创建时间
        var send = ''
    }else{
        if(!sendtime.value){
            ElMessage.error('请选择定时发送时间')
            return
        }
        if(sendtime.value <= getNowDate()){
            ElMessage.error('定时发送时间需大于当前时间')
            return
        }
        var send = sendtime.value
    }

    //判断是全部发送还是筛选发送,还是感叹号
    if(text_type1.value){
        //全部
        var conType = 0
    }else if(text_type2.value){
        //筛选
        var conType = 1
    }else if(text_type3.value){
        //按录入号码
        var conType = 2
    }

    
    
    // 修改网页content
    for(var x = 0;x<ready_list.data.length;x++){
        if(ready_list.data[x].msg_type=="Link"){
            ready_list.data[x].content=JSON.stringify(ready_list.data[x].jcontent)
        }
    }


    //筛选
    var obj = {
        "condition":{
                mobiles:[],
                tag_ids:[],
                channel_ids:[],
                equal:1,
                start_time:'',
                end_time:'',
            }
    }

    if(text_type1.value){

    }else if(text_type2.value){

        obj.condition.tag_ids = shaixuan().tag_list//标签
        obj.condition.channel_ids = shaixuan().quDaoIdsstr//选择渠道
        obj.condition.start_time  = shaixuan().startTime//开始时间
        obj.condition.end_time = shaixuan().endTime//结束时间
        obj.condition.equal  = shaixuan().isExitstr//是否排除
        obj.condition.corp_id = corp_id.value//企业主体


    }else if(text_type3.value){
        console.log(excelfile.value)

        if(importType.value=='phone'){
            obj.condition.mobiles = excelfile.value
        }else{
            obj.condition.contact_ids = contactidsfile.value
        }
    }

    //发送内容编码
    var newsendarr = []
    for(var x = 0;x<ready_list.data.length;x++){
        // newsendarr.push({msg_type:ready_list.data[x].msg_type,content:ready_list.data[x].content})
        newsendarr.push({msg_type:ready_list.data[x].msg_type,content:encode(ready_list.data[x].content)})
    }

    // console.log(ready_list.data)
    var message = {
            title:sendtitle.value,//发送标题
            // conType:conType,//判断是全部发送还是筛选发送或敢探号
            // gthId:gthId,
            content: JSON.stringify(newsendarr),//发送内容
            // content: ready_list.data,//发送内容
            // between_time: 1, // 发消息间隔时间
            execute_at: send, // 执行时间
            // accountid: 1,
            // tasktype: 1, // 1、群发客户；2、群发联系人；3、群发群聊
            condition:obj['condition'],
            // cid:0,
            // sucessPhoneArr:sucessPhoneArr
            // wechatid: '1688857350364979', // 要执行的微信号
            // wechatList: ["7881302299094459"], // 好友的微信号
            corp_id:corp_id.value,
        }

        console.log('发送')
        console.log(message)

        newcreateall(message).then((response)=>{
            console.log(response)
            if(response.data.msg.code==0){
                ElMessage({
                    message: '发送成功！',
                    type: 'success',
                })
                // location.reload();
                // 返回
                goBack()
            }else{
                console.log(ready_list.data)
                ElMessage.error(response.data.message)
            }
        })
}

//全部主体
const allcomp = reactive({
    data:[]
})

//获取主体
const getcomplist = ()=>{
  newgetcomp2().then((response)=>{
    if (response.data.msg.code == 0) {
        console.log('获取主体')
        console.log(response)
        //添加全部主体
        // allcomp.data.push({
        //     id: 0,
        //     corp_name: "全部",
        // })
        //添加主体
        response.data.data.forEach(item => {
            allcomp.data.push({
                id: item.id,
                corp_name: item.corp_name,
            })
        });
    }
  })
}

//导入类型（phone=手机号，contactid=客户ID）
const importType = ref('phone')
//上传手机号
const excelfile = ref([])
//上传客户ID
const contactidsfile = ref([])

//下载导入模板
const downloadExcel = ()=>{
    const a = document.createElement('a');
        a.setAttribute('download', '');
        const template = importType.value=='phone' ? '/wenjian/phone.xls' : '/wenjian/contactid.xls';
        a.setAttribute('href', location.origin+template);
        a.click();
        console.log(location.origin+template)
}



//导入表格获取数据
const getxslx = ()=>{
       
        let {utils, read} = XLSX; //解构
        let fileSelector = document.createElement('input');
        fileSelector.setAttribute('type', 'file');
        fileSelector.click();
 
        fileSelector.onchange = e => {
            let files = e.target.files; //文件信息
            let fileReader = new FileReader(); //创建读取器
             console.log('导入表格获取数据')
            fileReader.readAsBinaryString(files[0]); //读取文件的内容为二进制
             console.log('导入表格获取数据')
            // 读取完成
            fileReader.onload = event => {
                let data = event.target.result;
                let workbook = read(data, {type: 'binary'}); //读取工作簿
                let sheetName = workbook.SheetNames[0]; //取第一张表
                let worksheet = workbook.Sheets[sheetName];
                let jsonData = utils.sheet_to_json(worksheet, {header: 1}); //生成json表格内容
                let dataRows = jsonData.slice(1);
                let flatArray = dataRows.flat();
                console.log(flatArray);
                //去空值
                let list = flatArray.map(item => String(item).trim()).filter(item => item !== '');
                if(importType.value=='phone'){
                    excelfile.value = list
                    contactidsfile.value = []
                }else{
                    //客户ID只保留正整数
                    contactidsfile.value = list.map(Number).filter(n => Number.isInteger(n) && n > 0)
                    excelfile.value = []
                }
                //获取数据格式
                // [
                //   ['订单号*', '订单来源', '套餐名称*'],//表头
                //   ['时间=', '姓名=', '地址='],//数据
                //   ['时间=2', '姓名=2', '地址=2']//数据
                // ]
            }
        }
    }
//////////////////////////////////

//选择标签组件需要的数据

//选中的标签数组
const choosedtag = reactive({
    data:[]
})
//监听子组件传来的数据
const changechoosedtag = (e)=>{
    choosedtag.data = e
}
// 全部标签
const bqData = reactive({
    data:[]
})
//监听子组件传来的数据
const changebqData = (e)=>{
    bqData.data = e
}
//获取标签列表
const getbqlist = ()=>{
    newgettaglist().then((response)=>{
        console.log('标签')
        console.log(response)
        if (response.data.msg.code == 0) {
            bqData.data = response.data.data
            // console.log('response.data.result')
            console.log(response.data.data)
            //添加是否选中状态
            for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tags.length;x++){
                    bqData.data[i].tags[x].checked=false
                }
            }
        }
    })
}
////////////////////////////////
</script>

<style scoped>
.t_sxtips{
    background-color: #F1F3F9;
    border: 1px solid #4F46E5;
    display: flex;
    font-size: 14px;
    /* justify-content: space-between; */
    padding: 10px 15px;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
}
:deep(.el-input__wrapper)   {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.t_tiaojian_box{
    background-color: #F1F3F9;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 20px;
    width: 600px;
}
.t_tiaojian_item{
    display: flex;
    align-items: center;
    font-size: 15px;
    margin-bottom: 20px;
}
:deep(.t_tiaojian_item .el-input__wrapper)  {
    background-color: white;
    box-shadow: 0 0 0 1px #dcdfe6;
    flex-grow:unset;
    width: 100%;
}
.t_line_gray_dash{
    border-bottom: 1px dashed #c5c5c5;
    margin-top: 20px;
    margin-bottom: 20px;
}
.t_js_box{
    font-size: 13px;
    color: #777777;
    margin-top: 20px;
    display: flex;
}
.t_js_box span{
    color: #4F46E5;
    cursor: pointer;
}
.t_line{
    width: 100%;
    height: 1px;
    background-color: #DBDBDB;
    margin-top: 30px;
    margin-bottom: 30px;
}
.t_speak_box{
    width: 600px;
    border: 1px solid #c2c2c2;
    border-radius: 5px;
  }
  :deep(.t_speak_input .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    /* background-color: #F1F3F9; */
    resize: none;
  }
  .t_web_con{
    width: 400px;
    border: 1px solid #4F46E5;
    border-radius: 5px;
  }
  :deep(.t_web_con .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    background-color: #F1F3F9;
    resize: none;
  }
  .t_emoji_img{
    width: 20px;
    margin-left: 20px;
    margin-top: 5px;
    cursor: pointer;
  }
  .t_sendytpe_box{
    display: flex;
    background: #f6f6fa;
    font-size: 13px;
    padding: 0px 17px;
    color: #B0B0B0;
    line-height: 30px;
  }
  .t_sendytpe_box div{
    cursor: pointer;
  }
  .t_sendytpe_lei{
    color: #4F46E5;
    border-bottom: 2px solid #4F46E5;
  }
  .avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar2 {
    width: 178px;
    height: 178px;
    display: block;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
  }
 :deep(.avatar-uploader .el-upload)  {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep(.avatar-uploader .el-upload:hover)  {
  border-color: var(--el-color-primary);
}

:deep(.el-icon.avatar-uploader-icon)  {
  font-size: 29px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
.t_ready_msg{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    cursor: pointer;
}
.t_gth_list{
    display: flex;
    background: #f0f9fe;
    padding: 6px 30px 6px 15px;
    width: 640px;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}
</style>